import React from 'react';

const Logo = ({ className, variant = 'default' }) => {
  // Colors based on the user's image
  // variant 'dark' is for dark backgrounds (Gold logo)
  // variant 'light' is for light backgrounds (Dark/Black logo)
  // default falls back to current text color
  
  const goldColor = "#F2B300";
  const darkColor = "#1C1F23";
  
  let fillColor = "currentColor";
  if (variant === 'dark') fillColor = goldColor;
  if (variant === 'light') fillColor = darkColor;

  return (
    <svg 
      viewBox="0 0 200 160" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      aria-label="EVO TAXI Logo"
    >
      {/* Text: EVO */}
      <text 
        x="10" 
        y="65" 
        fontFamily="Arial, Helvetica, sans-serif" 
        fontWeight="900" 
        fontSize="65" 
        fill={fillColor}
        style={{ letterSpacing: '-0.02em' }}
      >
        EVO
      </text>
      
      {/* Text: TAXI */}
      <text 
        x="10" 
        y="125" 
        fontFamily="Arial, Helvetica, sans-serif" 
        fontWeight="900" 
        fontSize="65" 
        fill={fillColor}
        style={{ letterSpacing: '-0.02em' }}
      >
        TAXI
      </text>

      {/* Horizontal Bar under TA */}
      <rect 
        x="10" 
        y="140" 
        width="80" 
        height="8" 
        rx="4" 
        fill={fillColor} 
      />

      {/* Car Icon in Circle */}
      <g transform="translate(130, 110)">
        {/* Circle Stroke */}
        <circle 
          cx="30" 
          cy="30" 
          r="26" 
          stroke={fillColor} 
          strokeWidth="6" 
          fill="none"
        />
        
        {/* Car Silhouette */}
        <path 
          d="M15 35 
             L18 25 
             Q20 18 30 18 
             T42 25 
             L45 35 
             V42 
             H15 
             V35 
             M20 42 V46 M40 42 V46
             M18 28 H42" 
          stroke={fillColor} 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          fill="none"
        />
        {/* Headlights */}
        <circle cx="20" cy="35" r="2" fill={fillColor} />
        <circle cx="40" cy="35" r="2" fill={fillColor} />
      </g>
    </svg>
  );
};

export default Logo;
